document.addEventListener("DOMContentLoaded", function() {
  var videoElement = document.getElementById("video-element");
  var videoPlaceholder = document.getElementById("video-placeholder");

  // Add event listeners to the video element
  videoElement.addEventListener("loadeddata", function() {
    // Hide the placeholder and display the video
    videoPlaceholder.style.display = "none";
    videoElement.style.display = "block";
  });

  videoElement.addEventListener("error", function() {
    // Handle any error that occurs while loading the video
    // You can replace the placeholder with an error message or take appropriate action
  });
});